const permissions = {
  is_in_department: 'Работает в отделе',
  is_in_company: 'Работает в организации',
  can_execute_expertise: 'Проводит экспертизу',
  can_evaluate_agencies: 'Оценивает агентства',
  can_manage_dict_gnvlp: 'Ведёт справочник показаний',
}

export default permissions
